var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentType,{tag:"component",attrs:{"to":_vm.to},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.closeNav.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }